export default name => {
    const regex = /(download)\/(.{1,255})(-ref-[0-9]{10,20})(\.pdf)/gm;
    let file = regex.exec(name);

    return `${file[2]}${file[4]}`;
}